import type { TimelineHour } from "../api/types";

import { GUST_ABS_THRESHOLD, GUST_DELTA, GUST_MIN } from "./windDisplay";

export const DISPLAY_POP_THRESHOLD = 15;
export { GUST_ABS_THRESHOLD, GUST_DELTA, GUST_MIN };

export const PRECIP_BASE = {
  rain: "var(--color-weather-rain)",
  snow: "var(--color-weather-snow)",
  ice: "var(--color-weather-ice)",
} as const;

export type PrecipType = keyof typeof PRECIP_BASE;

const PRECIP_FIELD: Record<PrecipType, keyof TimelineHour> = {
  rain: "rainPopPct",
  snow: "snowPopPct",
  ice: "icePopPct",
};

export function tintOpacity(pop: number | null): number {
  if (pop === null || pop <= 0) return 0;
  if (pop <= 20) return 0.25;
  if (pop <= 40) return 0.45;
  if (pop <= 60) return 0.65;
  if (pop <= 80) return 0.85;
  return 1;
}

export function hourPop(hour: TimelineHour, type: PrecipType): number | null {
  const value = hour[PRECIP_FIELD[type]];
  return typeof value === "number" ? value : null;
}

export function activePrecipTypes(hours: TimelineHour[]): PrecipType[] {
  const types: PrecipType[] = [];
  for (const type of ["rain", "snow", "ice"] as const) {
    const maxPop = Math.max(...hours.map((h) => hourPop(h, type) ?? 0));
    if (maxPop >= DISPLAY_POP_THRESHOLD) {
      types.push(type);
    }
  }
  return types;
}

export function gustVisible(windMph: number | null, gustMph: number | null): boolean {
  if (gustMph === null) return false;
  if (gustMph >= GUST_ABS_THRESHOLD) return true;
  const wind = windMph ?? 0;
  return gustMph >= wind + GUST_DELTA && gustMph >= GUST_MIN;
}
